/**
 * Request builders for admin-only endpoints (/api/admin/*).
 */

export function reprocessSource(id: string) {
  return {
    url: `/api/admin/sources/${encodeURIComponent(id)}/reprocess`,
    method: 'POST' as const,
    options: { isMetaRequest: true },
  };
}
